import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import IGridComponent from '../../../components/grid/i-grid.component';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { getMasterDataById } from '../../master-data/masterdata.services';
import { deleteChallan, getChallanByPOJOId, getChallanPrint, getNonPojoChallan } from '../order.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import { formatTo0Decimal, isEmpty } from '../../common/util.services';
import QualityStatusComponent from '../quality/quality-status.component';
import PrintIcon from '@mui/icons-material/Print';
import PDFChallanComponent from './pdf-challan.component';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { RemoveCircleOutlineTwoTone } from '@mui/icons-material';

const ChallanComponent = (props: any) => {
  const navigate = useNavigate();
  const appContext = useContext(AppContext);
  const params = useParams();
  const rows: GridRowsProp = [];
  const [challanData, setChallanData] = useState(rows); 
  const pojoId = params.pojoId;
  const [qltyData, setQltyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [openQlty, setOpenQlty] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const [rowData, setRowData] = useState(null);
  const {state} = useLocation();
  const {orderId, productId} = state || {}; 
  const columns: GridColDef[] = [
    { 
      field: 'challanCode', headerName: 'Challan', filterable: false, sortable: false, editable: false, width: 115,
      renderCell: (params) => { return <div className="cell-link"
      onClick={() => { openChallanPage(params.row) }}> {params.row.challanCode}</div> }
    },
    { 
      field: 'type', headerName: 'Type', filterable: false, sortable: false, editable: false, width: 90
    },
    { 
      field: 'inputCode', headerName: 'I/P Code', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params) => { return <div className={'NA' === params.row.inputCode ? "" : "cell-link"}
      onClick={() => { openSpecsPopup(params.row.inputCode, params.row.inputId) }}>{params.row.inputCode}</div>}
    },
    { 
      field: 'outputDesc', headerName: 'O/P Desc', filterable: false, sortable: false, editable: false, width: 150
    },
    { 
      field: 'plannedOutput', headerName: 'Plan O/P', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params: any) => isEmpty(params.row.plannedOutput) ? 'NA' : 
                                   formatTo0Decimal(params.row.plannedOutput) + ' ' + params.row.outputUom
    },
    { 
      field: 'quantity', headerName: 'Quantity', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params: any) => isEmpty(params.row.quantity) ? 'NA' : 
                                   formatTo0Decimal(params.row.quantity) + ' ' + params.row.outputUom
    },
    { 
      field: 'approvedQty', headerName: 'Approved', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params: any) => 'Material Issue' === params.row.type || 
                                    'Sale Issue' === params.row.type || 
                                    'Sale Return' === params.row.type || 
                                    'Disposal' === params.row.type ||
                                    'General Account' === params.row.type ||
                                    'Process Loss' === params.row.type ||
                                    'Sampling Account' === params.row.type ||
                                    'PO Return' === params.row.type ||
                                    'JO Return' === params.row.type ? 'NA' : 
                                    formatTo0Decimal(params.row.approvedQty) + ' ' + params.row.outputUom,
      cellClassName: (params) => {return 'Material Issue' === params.row.type || 
                                         'Sale Issue' === params.row.type || 
                                         'Sale Return' === params.row.type || 
                                         'Disposal' === params.row.type ||
                                         'General Account' === params.row.type ||
                                         'Process Loss' === params.row.type ||
                                         'Sampling Account' === params.row.type ||
                                         'PO Return' === params.row.type ||
                                         'JO Return' === params.row.type ||
                                         (('Goods Receipt' === params.row.type || 'Material Receipt' === params.row.type) && 
                                          params.row.approvedQty === params.row.quantity) ? '' : 'AdDiffN'}
    },
    { 
      field: 'materialCost', headerName: 'Material Cost', filterable: false, sortable: false, editable: false, width: 125,
      valueFormatter: (materialCost: any) => isEmpty(materialCost) ? 'NA' : '₹ ' + formatTo0Decimal(materialCost)
    },
    { 
      field: 'processingCost', headerName: 'Process Cost', filterable: false, sortable: false, editable: false, width: 125,
      valueFormatter: (processingCost: any) => isEmpty(processingCost) ? 'NA' : '₹ ' + formatTo0Decimal(processingCost)
    },
    { 
      field: 'totalCost', headerName: 'Total Cost', filterable: false, sortable: false, editable: false, width: 125,
      valueFormatter: (totalCost: any) => isEmpty(totalCost) ? 'NA' : '₹ ' + formatTo0Decimal(totalCost)
    },
    { 
      field: 'qltyStatus', headerName: 'Quality', filterable: false, sortable: false, editable: false, width: 70, align: 'center',
      renderCell: (params) => { 
        return (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            {'NA' === params.row.qltyStatus ? (
              <RemoveCircleOutlineTwoTone fontSize='small' color="secondary"/>
            ) : 'Checked' === params.row.qltyStatus ? (
              <CheckCircleOutlinedIcon fontSize='small' color="success"/>
            ) : (
              <CancelOutlinedIcon fontSize='small' color="error"/>
            )}
          </div>
        )
      }
    },
    { 
      field: 'print', headerName: 'Print', filterable: false, sortable: false, editable: false, width: 20,
      renderCell: (params) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
          <PrintIcon fontSize='small' color="secondary"/>
        </div>
      )
    }
  ];

  const openChallanPage = (row: any) => {
    if('Disposal' === row.type || 'Process Loss' === row.type || 
       'General Account' === row.type || 'Sampling Account' === row.type) {
      appContext.setDialogMessage('Editing not available for this challan.');
    } else {
      navigate('/order/challan/' + row.rowId, {state: {pojoId: null}});
    }
  }

  const handleCellDoubleClick = (value: any) => {
    const field = value.field;
    if('qltyStatus' === field && 'NA' !== value.row.qltyStatus) {
      setQltyData(value.row);
      setOpenQlty(true);
    }
  }

  const handleCellClick = (value: any) => {
    if('print' === value.field) {
      if('Disposal' === value.row.type || 'Process Loss' === value.row.type ||
         'General Account' === value.row.type || 'Sampling Account' === value.row.type) {
        appContext.setDialogMessage('Printing not available for this challan.');
        return;
      }

      getChallanPrint(value.row.rowId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setRowData(response.data);
          setOpenPrint(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  const openSpecsPopup = (inputCode: any, inputId: any) => {
    if('NA' !== inputCode) {
      setLoading(true);
      getMasterDataById(inputId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setSpecsData(response.data);
          setOpenSpecs(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const closeQlty = (event: any, reason: any) => {
    if('escapeKeyDown' !== reason) {
      setOpenQlty(false);
    }
  }

  const onCancel = () => {
    setOpenQlty(false);
  }

  const closePrint = () => {
    setOpenPrint(false);
  }

  const deleteChallanData = (row: any) => {
    setLoading(true);
    deleteChallan(row.rowId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        navigate(0);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const onSubmit = () => {
    setOpenQlty(false);
    navigate(0);
  }

  useEffect(() => {
    if('0' === pojoId) {
      getNonPojoChallan(orderId, productId, appContext,
        (response: any) => {
          setChallanData(response.data);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    } else {
      getChallanByPOJOId(pojoId, appContext,
        (response: any) => {
          setChallanData(response.data);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
  }, []);

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={challanData} columns={columns} loading={loading} maxHeight={550} hideFooterPagination={true}
        showAddBtn={false} showApproveAction={false} showDeleteAction={true} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.rowId} hideFooter={true} showExtBtn={false} cellDoubleClick={handleCellDoubleClick}
        cellClick={handleCellClick} showAction={true} showEditAction={false} handleDeleteAction={deleteChallanData}/>
      <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={specsData} />} />
      <IDialogComponent onClose={closeQlty} open={openQlty} title='Quality Status'
        dialogBody={<QualityStatusComponent qltyData={qltyData} onCancel={onCancel} onSubmit={onSubmit}/>} />
      <IDialogComponent onClose={closePrint} open={openPrint} title='Print Challan'
        dialogBody={<PDFChallanComponent data={rowData}/>} />
    </>
  }

  return <TitlePanel title={'Challan(s)'} panelBody={getMainPanel()} />
}

export default ChallanComponent;